import { MedicationMatchingView } from "@/features/patient/medications/components/MedicationMatchingView";
import { useMedicationMatching } from "@/features/patient/medications/hooks/useMedicationMatching";

export function MedicationMatchingPage() {
  const { groups, isLoading, error } = useMedicationMatching();
  return <MedicationMatchingView groups={groups} isLoading={isLoading} error={error} />;
}
